import { NgModule } from '@angular/core';
import { AnimateInViewDirective } from './animate-in-view.directive';

@NgModule({
    exports: [AnimateInViewDirective],
    declarations: [AnimateInViewDirective],
})
export class AnimateInViewModule { }
